require('/cloud/source_code/node_modules/_@alife_cnc-cn-request-wms@2.0.0@@alife/cnc-cn-request-wms/es/style.js');
import net from "./utils/net";
import globalData from "./utils/globalData";
window.wmsnet = net;
window.globalData = globalData;
export default net;